// Dependencies
import axios from 'axios';
import { useDispatch } from 'react-redux';

// Variables
const baseURL = process.env.REACT_APP_API_URL;

// Dashboard API hook
export default function useDasboardApi() {

	// State and hooks
	const dispatch = useDispatch();

	// Get user types
	const getUserTypes = async () => {

		// Request
		const response = await axios.get(`${baseURL}/admin/user_type`, {
			headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			}
		});

		// // Convert to "select" format
		// const converted = response.data.data.map(item => ({ value: item.id.toString(), label: item.name }));

		// Assign and return
		dispatch.dashboardData.setUserTypes(response.data.data);
		return;

	}

	// Get emissions
	const getEmissions = async (startDate, endDate) => {

		// Call API
		try {

			// URL
			let finalURL = `${baseURL}/admin/dashboard/total-co2`;
			finalURL = startDate && endDate ? finalURL + `?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}` : finalURL;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setTotalEmissions(response.data.data);
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Get distance
	const getDistance = async (startDate, endDate) => {

		// Call API
		try {

			// URL
			let finalURL = `${baseURL}/admin/dashboard/total-distance`;
			finalURL = startDate && endDate ? finalURL + `?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}` : finalURL;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setTotalDistance(response.data.data);
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Get time
	const getTime = async (startDate, endDate) => {

		// Call API
		try {

			// URL
			let finalURL = `${baseURL}/admin/dashboard/total-time`;
			finalURL = startDate && endDate ? finalURL + `?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}` : finalURL;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setTotalTime(response.data.data);
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Get benefits per level
	const getBenefitsPerLevel = async () => {

		// Call API
		try {

			// URL
			let finalURL = `${baseURL}/admin/dashboard/total-benefits-per-level`;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setTotalBenefitsPerLevel(response.data.data);
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Get active users
	const getActiveUsers = async (filters) => {

		// Call API
		try {

			// URL
			let finalURL = `${baseURL}/admin/dashboard/active-users?userTypes=${filters.join(',')}`;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setActiveUsers(response.data.data);
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Get user evolution
	const getUserEvolution = async (startDate, endDate, filters) => {

		// Call API
		try {

			// URL
			let finalURL = `${baseURL}/admin/dashboard/register-evolution?userTypes=${filters.join(',')}`;
			finalURL = startDate && endDate ? finalURL + `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}` : finalURL;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setUserEvolution(response.data.data.evolution.sort((a, b) => new Date(a.date) - new Date(b.date)));
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Get user activity zones
	const getUserActivityZones = async (startDate, endDate, filters) => {

		// Call API
		try {

			// Start date
			var finalStartDate = startDate === '' ? new Date(new Date().setDate(new Date().getDate() - 30)) : startDate;

			// Default filters
			filters = filters.length === 0 ? [0, 1, 2, 3, 4, 5, 6] : filters;

			// URL
			let finalURL = `${baseURL}/admin/dashboard/heatmap?startDate=${encodeURIComponent(finalStartDate)}&endDate=${encodeURIComponent(endDate)}&weekDays=${filters.join(',')}`;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setUserZoneActivity(response.data.data);
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Get active users stats
	const getActiveUsersStats = async (startDate, endDate, filters) => {

		// Call API
		try {

			// URL
			let finalURL = `${baseURL}/admin/dashboard/active-users-stats?userTypes=${filters.join(',')}`;
			finalURL = startDate && endDate ? finalURL + `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}` : finalURL;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setActiveUsersStats(response.data.data);
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Get active users heatmap
	const getActiveUsersHeatmap = async (startDate, endDate, filters) => {

		// Call API
		try {

			// URL
			let finalURL = `${baseURL}/admin/dashboard/activities-frecuency?userTypes=${filters.join(',')}`;
			finalURL = startDate && endDate ? finalURL + `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}` : finalURL;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setActiveUsersHeatmap(response.data.data);
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Get benefit information
	const getBenefitInformation = async () => {

		// Call API
		try {

			// URL
			let finalURL = `${baseURL}/admin/dashboard/benefits`;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setBenefitInformation(response.data.data.sort((a, b) => a.level - b.level));
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Get benefit performance
	const getBenefitPerformance = async (startDate, endDate, statusFilter, userFilter, levelFilter) => {

		// Call API
		try {

			// URL
			let finalURL = `${baseURL}/admin/dashboard/benefits-performance?userTypes=${userFilter}&active=${statusFilter}&levels=${levelFilter}`;
			finalURL = startDate && endDate ? finalURL + `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}` : finalURL;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setBenefitPerformance(response.data.data);
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Get posts information
	const getPostsInformation = async (filters) => {

		// Call API
		try {

			// URL
			let finalURL = `${baseURL}/admin/dashboard/posts?postCategoryId=${filters.join(',')}`;

			// Request
			const response = await axios.get(finalURL, {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
				}
			});

			// Assign and return
			dispatch.dashboardData.setPostsGeneral(response.data.data);
			return;

		} catch (error) {

			// Log/return error
			console.error(error);
			return error;

		}

	};

	// Return
	return { getUserTypes, getEmissions, getDistance, getTime, getBenefitsPerLevel, getActiveUsers, getUserEvolution, getUserActivityZones, getActiveUsersStats, getActiveUsersHeatmap, getBenefitInformation, getBenefitPerformance, getPostsInformation };

}
